export type CustomerNotice={id:string,message:string,createTime:string|number,readed:boolean|number,targetType?:string,targetId?:string|number,orderType?:string|number}
export const notificationCenter='/main/cuscenter/security-notifications'
export const noticeIdAtMost=(id:string,maxId:string)=>/^\d+$/.test(id) && /^\d+$/.test(maxId) && (id.length<maxId.length || id.length===maxId.length && id<=maxId)
export const normalizeNotice=(row:any):CustomerNotice|null=>{
  if(!row || !/^[1-9]\d*$/.test(String(row.id || '')) || typeof row.message!=='string' || !row.message.trim())return null
  return {...row,id:String(row.id),readed:row.readed===true || row.readed===1 || row.readed==='1'}
}
export const noticeDestination=(item:CustomerNotice):string=>{
  const id=String(item.targetId || '')
  const fallback=/^[1-9]\d*$/.test(item.id)?notificationCenter+'?noticeId='+item.id:notificationCenter
  if(!/^[1-9]\d*$/.test(id))return fallback
  if(item.targetType==='drawing')return '/main/cuscenter/drawing-patterns?id='+id
  if(item.targetType==='order'){
    const type=Number(item.orderType)
    if([1,2,5,6,7].includes(type))return `/main/cuscenter/orderconfirm?id=${id}&orderType=${type}`
    if([3,4,8,9,10,11].includes(type))return '/main/cuscenter/clothorderconfirm?id='+id
  }
  return fallback
}
